/**
 * Common editor prose styles shared between RichTextEditor and RichTextDisplay
 */
export const RICH_TEXT_EDITOR_PROSE_CLASSES = [
  "prose prose-sm max-w-none focus:outline-none break-words",
  // Heading styles
  "[&_h1]:text-3xl [&_h1]:font-bold [&_h1]:mb-4",
  "[&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mb-3",
  "[&_h3]:text-xl [&_h3]:font-bold [&_h3]:mb-2",
  // List styles
  "[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-2",
  "[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:my-2",
  "[&_li]:my-1",
  // Blockquote styles
  "[&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:my-4",
  // Code styles
  "[&_code]:bg-gray-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-sm",
  "[&_pre]:bg-gray-100 [&_pre]:p-4 [&_pre]:rounded [&_pre]:overflow-x-auto [&_pre]:my-4",
  // Horizontal rule styles
  "[&_hr]:border-t [&_hr]:border-gray-300 [&_hr]:my-8",
  // Paragraph styles
  "[&_p]:my-3",
  // Link styles
  "[&_a]:text-primary [&_a]:underline [&_a]:cursor-pointer [&_a]:hover:opacity-80",
  // Image styles
  "[&_img]:max-w-full [&_img]:h-auto [&_img]:rounded-md [&_img]:my-4",
] as const;
